var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuBeach(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9411 20.9379C20.183 19.18 17.7986 18.1924 15.3123 18.1924C12.8261 18.1924 10.4417 19.18 8.68359 20.9379",
    stroke: "#3653C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4999 4.75479C20.7773 3.76028 18.7302 3.49077 16.8089 4.00555C14.8876 4.52033 13.2495 5.77725 12.2549 7.49979L25.2449 14.9998C26.2394 13.2772 26.5089 11.2301 25.9941 9.3088C25.4793 7.38751 24.2224 5.74939 22.4999 4.75479V4.75479Z",
    stroke: "#3653C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.915 12.5001C22.9875 8.9126 23.6962 5.4451 22.5 4.7551C21.3037 4.0651 18.6562 6.4126 16.585 10.0001",
    stroke: "#3653C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 11.25L15 17.745",
    stroke: "#3653C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 24.0622C4.13912 23.8687 4.56562 23.7621 5 23.7497C5.48687 23.7395 5.9689 23.848 6.40447 24.0657C6.84003 24.2835 7.21604 24.6041 7.5 24.9997C7.78396 25.3953 8.15997 25.7158 8.59553 25.9336C9.0311 26.1514 9.51313 26.2599 10 26.2497C10.4869 26.2599 10.9689 26.1514 11.4045 25.9336C11.84 25.7158 12.216 25.3953 12.5 24.9997C12.784 24.6041 13.16 24.2835 13.5955 24.0657C14.0311 23.848 14.5131 23.7395 15 23.7497C15.4869 23.7395 15.9689 23.848 16.4045 24.0657C16.84 24.2835 17.216 24.6041 17.5 24.9997C17.784 25.3953 18.16 25.7158 18.5955 25.9336C19.0311 26.1514 19.5131 26.2599 20 26.2497C20.4869 26.2599 20.9689 26.1514 21.4045 25.9336C21.84 25.7158 22.216 25.3953 22.5 24.9997C22.784 24.6041 23.16 24.2835 23.5955 24.0657C24.0311 23.848 24.5131 23.7395 25 23.7497C25.4344 23.7621 25.8609 23.8687 26.25 24.0622",
    stroke: "#3653C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBeach);
export default __webpack_public_path__ + "static/media/menu_beach.94a9b64a.svg";
export { ForwardRef as ReactComponent };